import type { QueryClient } from '@tanstack/react-query'
import { createRouter as createTanStackRouter } from '@tanstack/react-router'

import { DefaultErrorPage } from '@/components/default-error-page'
import { DefaultNotFoundPage } from '@/components/default-not-found-page'

import { queryClient } from './query-client'
import { routeTree } from './route-tree.gen'

export type RouterContext = {
  queryClient: QueryClient
  app: 'gw-admin'
}

export function createRouter() {
  const router = createTanStackRouter({
    routeTree,
    defaultPreload: 'intent',
    scrollRestoration: true,
    defaultErrorComponent: DefaultErrorPage,
    defaultNotFoundComponent: DefaultNotFoundPage,
    context: { queryClient, app: 'gw-admin' },
  })

  return router
}

declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: ReturnType<typeof createRouter>
  }
}
